import styled, { css } from 'styled-components';
import { color, size, animation } from './helpers/variables';
import { hideOnPrint } from './helpers/mixins';

export const ProductImage = styled.img`
  width: 100%;
  max-height: 100%;
  height: auto;
  object-fit: contain;
  display: block;
  margin: ${props => (props.swipe ? '0' : '2rem 0')};
  transition: transform ${animation.transitionTime} ${animation.easing};

  padding-left: ${props =>
    props.swipe ? `calc(8px + ((80 - 8) * ((100vw - ${size.small}px) / (${size.large} - ${size.small}))))` : '0'};
  padding-right: ${props =>
    props.swipe ? `calc(8px + ((80 - 8) * ((100vw - ${size.small}px) / (${size.large} - ${size.small}))))` : '0'};

  ${props =>
    props.margin &&
    css`
      margin: ${props.margin};
    `};

  ${props =>
    props.round &&
    css`
      max-height: unset;
      border-radius: 100%;
    `};
  
  ${props => props.disabled && css`
    opacity: .6;
  `};

  border: 1px solid transparent;

  ${props =>
    props.selected &&
    css`
      border: 1px solid ${color.primary};
    `};

  ${props =>
    props.round &&
    css`
      border-radius: 100%;
      max-height: initial;
    `};
  
  ${props => props.hideOnPrint && hideOnPrint};
`;



// WEBPACK FOOTER //
// ./src/styles/ProductImage.js